import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab, Tabs } from "@mui/material";
import CustomerIndex from "./CustomerIndex";
import React from "react";
import BiggestOpportunities from "./Common/BiggestOpportunities";
    
export default function DataWhisperFeed(props: { customer_index: string, customer_id: number, mode: string, biggest_opportunities: string }){
    const [value, setValue] = React.useState('A');
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
            <Box sx={{ width: '100%', typography: 'body1', height: '100%', margin: 0, paddingTop: 0, backgroundColor: 'white', borderRadius: '6px !important' }}>
                <TabContext value={value}>
                    <Box sx={{ width: '100%', display: 'flex', borderBottom: 1, borderColor: 'divider', justifyContent: 'center', padding: 0 }}>
                        <Tabs 
                            variant="scrollable"
                            scrollButtons
                            allowScrollButtonsMobile
                            selectionFollowsFocus
                            onChange={handleChange} 
                            aria-label="lab API tabs example" 
                            value={value}
                        >
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="All" value="A" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Monthly Concerns" value="M" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Revenue Expansion" value="R" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Operational Efficiency" value="O" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Price Recovery" value="P" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Trends" value="T" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Open Quotes" value="Q" />
                            {/* <Tab wrapped style={{ textTransform: 'capitalize' }} label="Corporate Communications" value="C" /> */}
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Top 5 Opportunities" value="5" />
                        </Tabs>
                    </Box>
                    {value !== '5' ? (
                        <TabPanel value={value} sx={{ margin: 0, padding: 0 }}>
                            <Box sx={{ width: '100%', typography: 'body1', height: '100%', display: 'flex', justifyContent: 'center' }}>
                                <CustomerIndex value={value} customer_index={props.customer_index} customer_id={props.customer_id} mode={props.mode} />
                            </Box>
                        </TabPanel>
                    ) : (
                        <TabPanel value={'5'} sx={{ margin: 0, padding: 0 }}>
                            <BiggestOpportunities biggest_opportunities={props.biggest_opportunities} />
                        </TabPanel>
                    )}
                </TabContext>
            </Box>
        </Box>
    )
}